<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="studentRankListPush"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-teacher-select="true"
    :is-show-tag-name="true"
    :is-show-search-input="true"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
    :is-show-major-switch="true"
    :is-show-xls-export-button="true"
    :picker-options="pickerOptions"
    default-order-by="hours"
    excel-name="上课排名列表"
    :excel-data="xlsData"
    :isShowExportALl="true"
    :isExportingAll="isExporting"
    :exportAllText="`导出全部至 Excel${isExporting ? '（' + Math.min(currentExportPage * 30, count) + ' / ' + count + '）' : ''}`"
    @exportAllExcel="exportAllExcel"
  >
    <el-table-column label="排名">
      <template v-slot="{ $index }">NO.{{ (queryList.page - 1) * (queryList.size || 10) + $index + 1 }}</template>
    </el-table-column>

    <el-table-column label="上课次数" prop="hours" :sort-orders="['ascending', 'descending']"/>

    <v-column-student label="学员"/>

    <el-table-column label="手机号" prop="phone"/>

    <el-table-column label="会员卡号" prop="card_number"/>

    <el-table-column label="课卡数量" prop="card_count"/>

    <v-column-time value="注册时间" sortable=""/>

    <el-table-column label="操作">
      <template v-slot="{ row }">
        <v-list-button name="修改" :to="studentEditTo(row.id)"/>

        <v-list-button
          name="注销"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeletingIds.includes(row.id)"
          message="学员账号将被注销，小程序将自动退出登录，确认要继续操作吗？"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>排名</span>
              <span>NO.{{ (queryList.page - 1) * (queryList.size || 10) + k + 1 }}</span>
            </div>

            <div class="list-item-detail">
              <span>上课次数</span>
              <span>{{ v.hours || 0 }} 次</span>
            </div>

            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>会员卡号</span>
              <span>{{ v.card_number }}</span>
            </div>

            <div class="list-item-detail">
              <span>拥有课卡数量</span>
              <span>{{ v.card_count }} 张</span>
            </div>

            <div class="list-item-detail">
              <span>注册时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button name="修改" :to="studentEditTo(v.id)"/>

              <v-list-button
                name="注销"
                icon="bin"
                @click="handleDelete(v)"
                :is-loading="isDeletingIds.includes(v.id)"
                message="学员账号将被注销，小程序将自动退出登录，确认要继续操作吗？"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { getStudentRanks, destroy } from '@/api/student';
import { removeArrayItem } from "@/utils";
import { timeToYmdHi } from "@/filters";
import exportExcel from '@/utils/excel-export';

export default {
  name: RouteConfig.studentRankList.name,
  data: () => ({
    RouteConfig,
    studentEditTo: RouteConfig.studentEdit.to,
    studentRankListPush: RouteConfig.studentRankList.push,
    isLoading: false,
    isDeletingIds: [],
    isExporting: false,
    currentExportPage: 0,
    timeLimit: [],
    count: 0,
    list: [],
    xlsData: [],
    pickerOptions: {
      disabledDate: (time) => time.getTime() >= Date.now(),
    },
    queryList: {
      is_asc: 0,
      is_major: 0,
      start_date: '',
      end_date: '',
      tag_name: '',
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
    queryList(queryList) {
      this.timeLimit = [queryList.start_date, queryList.end_date];
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.studentRankList.push(this.queryList);
    },
    handleTeacherChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleTimeLimitChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date, end_date] = times;

      Object.assign(this.queryList, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },
    async load(route = this.$route) {
      this.count = 0;
      this.list = [];

      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getStudentRanks(queryList);
      this.isLoading = false;
      if (isError) return;
      if (!data.list) return;

      this.count = data.count || 0;
      this.list = data.list || [];
      this.xlsData = this.setXlsData(data.list);
    },
    // 组装导出的 Excel 行数据，排名按当前页起始位置计算
    setXlsData(list) {
      const startRank = (this.queryList.page - 1) * (this.queryList.size || 10);
      return list.map((item, index) => ({
        '排名': startRank + index + 1,
        '上课次数': item.hours || 0,
        '学员': item.student_name,
        '手机号': item.phone,
        '会员卡号': item.card_number,
        '课卡数量': item.card_count,
        '注册时间': timeToYmdHi(item.add_time),
      }));
    },
    // 导出全部至 Excel：按当前筛选条件逐页拉取（后台不计数不缓存），全部成功后一次性导出
    async exportAllExcel() {
      if (this.isExporting) return;

      if (!this.count) return this.$message({
        message: '暂无数据可以导出',
        type: 'info',
        duration: 5000,
      });

      const isConfirm = await this.$confirm(
        `此操作将导出共计 ${this.count} 条数据, 导出过程中不可关闭此页面，确定是否要继续？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).catch(() => {});
      if (!isConfirm) return;

      this.isExporting = true;
      try {
        // 拷贝当前筛选条件，逐页翻查时不污染页面状态
        const params = { ...this.queryList };
        getLegalQueryList(params, this.$route.query);

        Object.assign(params, {
          is_only_list: 1, // 只取列表，不计数不走缓存
          page: 1,
          size: 30,
        });

        let list = [];
        const maxPage = Math.ceil(this.count / 30);
        for (let page = 1; page <= maxPage; page++) {
          params.page = page;
          this.currentExportPage = page;
          const { isError, data } = await getStudentRanks(params);
          if (isError || !data) {
            this.$message({
              message: '导出失败，请重试',
              type: 'error',
              duration: 5000,
            });
            return;
          }
          list = list.concat(data.list || []);
        }

        // 逐页按序拉取，整体排序不变，故按数组顺序即为全局排名
        exportExcel(list.map((item, index) => ({
          '排名': index + 1,
          '上课次数': item.hours || 0,
          '学员': item.student_name,
          '手机号': item.phone,
          '会员卡号': item.card_number,
          '课卡数量': item.card_count,
          '注册时间': timeToYmdHi(item.add_time),
        })), '上课排名列表');
      } finally {
        this.isExporting = false;
      }
    },
    async handleDelete({ id }) {
      this.isDeletingIds.push(id);
      const { isError } = await destroy(id);
      removeArrayItem(this.isDeletingIds, id);
      if (!isError) this.load();
    },
  },
};
</script>
